/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const JOBSTREAM_DATA = "jobstreamData";
const LAST_TEN_RUNS_CHART = "lastTenRunsChart";
const DATA_CHART_START_TIME = "dataChartStartTime";
const DATA_CHART_DURATION = "dataChartDuration";
const GRAPH = "graph";

module.exports = {
    JOBSTREAM_DATA,
    LAST_TEN_RUNS_CHART,
    DATA_CHART_START_TIME,
    DATA_CHART_DURATION,
    GRAPH,
}